import React from "react";
import { NavLink } from 'react-router-dom';


import './NavLinks.css';

const NavLinks = (props) => {
    return (
        <div className={`navlink-wrapper ${props.className}`}>
            <NavLink className="navlink-item" to='/'>Home</NavLink>
            <NavLink className="navlink-item" to='/'>Service</NavLink>
            <NavLink className="navlink-item" to='/#about'>About</NavLink>
            <NavLink className="navlink-item" to='/'>Product</NavLink>
        </div>
    )
}

export default NavLinks;